import {
  BudgetRevenueAdminFindDto,
  type BudgetRevenueAdminFindInterface,
} from '@zaoblako/shared/modules/catalog/dtos/budget-revenue-admin/budget-revenue-admin-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';

import * as yup from 'yup';

/** Budget classification code response body - DTO signature */
export interface BudgetClassificationCodeFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: string;

  // Tech columns
  /** Budget classification code creation date and type */
  created: Date;
  /** Budget classification code last update date and type */
  updated: Date;
  /** Budget classification code soft deletion date and type */
  deleted?: Date;

  // Data columns
  /** Budget classification code unique code (20 digits) */
  code: string;
  /** Budget classification code display name */
  name: string;
  /** Budget revenue admin this budget classification code belongs to */
  budgetRevenueAdmin: BudgetRevenueAdminFindInterface;
}

/** Budget classification code response body - DTO schema */
export const BudgetClassificationCodeFindDto = SerdeDtoClass.create<BudgetClassificationCodeFindInterface>(
  CatalogDtosKeysEnum.BUDGET_CLASSIFICATION_CODE_FIND_DTO,
  {
    id: {
      sortable: true,
      label: 'Номер',
      serializer: yup.string(),
    },
    created: {
      sortable: true,
      label: 'Создан',
      serializer: yup.date(),
    },
    updated: {
      label: 'Изменен',
      serializer: yup.date(),
    },
    deleted: {
      optional: true,
      label: 'Удален',
      serializer: yup.date(),
    },
    code: {
      sortable: true,
      label: 'Код',
      serializer: yup.string(),
    },
    name: {
      sortable: true,
      label: 'Название',
      serializer: yup.string(),
    },
    budgetRevenueAdmin: {
      sortable: true,
      label: 'Администратор платежа',
      nested: BudgetRevenueAdminFindDto,
      serializer: (_, nested) => nested,
    },
  },
);
